module.exports = __webpack_public_path__ + "img/404graphics.a758b4e2.svg";